import { IExpertPhase, IWorkflowData } from "@publishing-engine/domain/models"
import { ReactNode } from "react";
import { StringTemplateData } from "src/utils/phaseCopy"
interface PhaseContent {
  heading: string | ((params: StringTemplateData) => string);
  description: string | ((params: StringTemplateData) => ReactNode);
}
export type IExpertPhases = IExpertPhase | 'adjudication'

type DocumentPhases = Record<IExpertPhases, PhaseContent>;

export const assessmentPhaseDescription: DocumentPhases = {
  invited: {
    heading: 'Invited',
    description: 'We invite you to assess this submission and provide an informed recommendation on its suitability. Your expertise is essential to guide editors in making well-informed decisions. Thank you for your thoughtful analysis and feedback.'
  },
  declined: {
    heading: 'Declined',
    description: 'The Editors has moved this Submission to another workflow phase, which means your work is no longer necessary. We appreciate any time you may have already spent on it.',
  },
  expired: {
    heading: 'Expired',
    description: '',
  },
  draft: {
    heading: 'Draft',
    description: 'We invite you to assess this submission and provide an informed recommendation on its suitability. Your expertise is essential to guide editors in making well-informed decisions. Thank you for your thoughtful analysis and feedback.',
  },
  reviewed: {
    heading: 'Completed',
    description: (params: StringTemplateData) => `Your assessment was sent to the Editors on ${params.dateSent}. You can only review the sent information.`,
  },
  assessment: {
    heading: 'In Progress',
    description: 'We invite you to assess this submission and provide an informed recommendation on its suitability. Your expertise is essential to guide editors in making well-informed decisions. Thank you for your thoughtful analysis and feedback.',
  },
  adjudication: {
    heading: 'In Progress',
    description: 'We invite you to assess this submission and provide an informed recommendation on its suitability. Your expertise is essential to guide editors in making well-informed decisions. Thank you for your thoughtful analysis and feedback.',
  },
  interrupted: {
    heading: 'Interrupted',
    description: 'The Editors has moved this Submission to another workflow phase, which means your work is no longer necessary. We appreciate any time you may have already spent on it.',
  }
}

export const getAssessmentCompletionDate = (
  workflowData?: IWorkflowData
) => {
  const EarlyAssessmentSubmittedWorkflowState = workflowData?.states?.find(
    state => state.name === 'EarlyAssessmentSubmitted'
  );

  return EarlyAssessmentSubmittedWorkflowState?.completedWith?.action ===
    'EarlyAssessmentSubmitted'
    ? EarlyAssessmentSubmittedWorkflowState.completedWith.date!
    : new Date().toISOString();
};